import axios from 'axios'
import { get } from 'lodash'

// ====================
// > Buy
// ====================
// TODO - Deprecated?? Delete??
const getBuy = ({commit, state}) => {
  return new Promise((resolve, reject) => {
    let ret
    if (state.checkinKey) {
      const uri = `${process.env.CHECKIN_URL}/${state.checkinKey}.json`
      axios.get(uri)
        .then((response) => {
          commit('setBuy', response.data)
        })
        .catch((error) => {
          reject(error)
        })
        .then(() => { ret = true })
    } else {
      ret = false
    }
    resolve(ret)
  })
}

const getBuyFromKey = ({commit, state}, checkinKey) => {
  return new Promise((resolve, reject) => {
    axios.get(`${process.env.CHECKIN_URL}/${checkinKey}.json`)
      .then((response) => {
        if (addressIsPrepopulated(response.data)) commit('setAddressIsPrepopulated', true)
        commit('setBuy', response.data)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const createBuy = ({commit, state}, buy) => {
  return new Promise((resolve, reject) => {
    const uri = `${process.env.CHECKIN_URL}`
    axios.post(uri, buy)
      .then((response) => {
        let buy = response.data
        commit('setBuy', buy)
        resolve(buy)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const updateBuy = ({commit, state}, buy) => {
  return new Promise((resolve, reject) => {
    const uri = `${process.env.CHECKIN_URL}/${state.checkinKey}.json`
    axios.patch(uri, buy)
      .then((response) => {
        let buy = (typeof response.data.details === 'string' && JSON.parse(response.data.details)) || response.data.details
        commit('setBuy', buy)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// ====================
// > Store
// ====================
const getNearbyStores = ({state}, coordinates) => {
  return new Promise((resolve, reject) => {
    const uri = `${process.env.SIGN_TO_SELL_API_URL}/stores?` +
      `location[latitude]=${coordinates.latitude}&` +
      `location[longitude]=${coordinates.longitude}`
    axios.get(uri)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const getStore = ({state, commit}, id) => {
  return new Promise((resolve, reject) => {
    const uri = `${process.env.SIGN_TO_SELL_API_URL}/stores/${id}`
    axios.get(uri)
      .then((response) => {
        commit('setRaiStore', response.data)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const getStoreFromNumber = ({state, commit}, number) => {
  return new Promise((resolve, reject) => {
    const uri = `${process.env.SIGN_TO_SELL_API_URL}/stores?store_number=${number}`
    axios.get(uri)
      .then((response) => {
        commit('setRaiStore', response.data)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// ====================
// > Confirmation
// ====================
const createConfirmationCode = ({state}, phoneNumber) => {
  const uri = `${process.env.SIGN_TO_SELL_API_URL}/phone_confirmations`
  const params = {
    phone_confirmation: {
      phone_number: phoneNumber
    },
    store: {
      id: state.raiStore.id
    }
  }
  return axios.post(uri, params)
}

const confirmCode = ({state}, payload) => {
  const uri = `${process.env.SIGN_TO_SELL_API_URL}/phone_confirmations?` +
    `phone_confirmation[phone_number]=${payload.phoneNumber}&` +
    `phone_confirmation[code]=${payload.code}`
  return axios.get(uri)
}

// ====================
// > Misc
// ====================
const getBuyAndStoreFromKey = ({dispatch, state, commit}, checkinKey) => {
  return new Promise((resolve, reject) => {
    dispatch('getBuyFromKey', checkinKey)
      .then(() => {
        dispatch('getStore', state.buy.store_id)
          .then(() => {
            resolve(true)
          })
          .catch((error) => {
            reject(error)
          })
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// ====================
// > Private
// ====================
const addressIsPrepopulated = (buy) => {
  return [
    'signin_address_1',
    'signin_address_2',
    'signin_city',
    'signin_state',
    'signin_postal_code'
  ].some(field => get(buy, field))
}

export default {
  getBuy,
  getBuyFromKey,
  createBuy,
  updateBuy,
  getNearbyStores,
  getStore,
  getBuyAndStoreFromKey,
  createConfirmationCode,
  confirmCode,
  getStoreFromNumber
}



// WEBPACK FOOTER //
// ./src/store/actions.js